<template>
  <div class="flex">
    <!-- <ul class="imgs" v-if="isSwitch">
      <li v-for="(item,index) in myFileList" :key="index">
        <el-image :src="item" :preview-src-list="fileList"></el-image>
        <span class="delete">
          <i class="el-icon-delete" @click="removeFileList(item,index)"></i>
        </span>
      </li>
    </ul>
    <ul v-else class="imgs">
      <li v-if="myFileList != ''">
        <el-image :src="myFileList" :preview-src-list="srcList"></el-image>
        <span class="delete">
          <i class="el-icon-delete" @click="removeFileList"></i>
        </span>
      </li>
    </ul>-->
    <el-upload
      :disabled="disabled"
      class="upload"
      :limit="1"
      action="#"
      :headers="{access_token: $store.getters.AppInfo.accessToken}"
      list-type="picture-card"
      :show-file-list="false"
      :before-upload="uploadImg"
      :class="[type == 'front' ? 'cardFrontImg':'cardBackImg']"
    >
      
      <img v-if="fileList" :src="fileList" alt />
    </el-upload>
  </div>
</template>

<script>
import OSS from "ali-oss";
import { compressImage } from "../../../assets/javascript/untils";
export default {
  props: {
    fileList: {
      type: [Array, String],
      default: []
    },
    module: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      srcList: [],
      isSwitch: true,
      myFileList: this.fileList || '',
      myHeaders: {},
      oss: null,
      ids: [],
      ossParmar: {}
    };
  },
  created() {
    
  },
  watch: {
    fileList() {
      this.myFileList = this.fileList;
    }
  },
  methods: {
    async confirmImg (file) {
      let ret = await this.$api.post(this.$url.merchatOss.listUploadId, {size: 1, module: this.module, securityType: this.ossParmar.securityType, bucketName: this.ossParmar.bucketName})
      if (ret) {
        this.ids = ret;
      }
      try {
        const imgPath = this.module + "/" + this.ids[0] + '.png';
        const result = await this.oss.put(imgPath, file);
        let arr = result.url.split('/');
        let url = this.ossParmar.imgDomain + '/' + arr[3] + '/' + arr[4];
        if (this.ossParmar.securityType == 'privated') {
          this.$api.get(this.$url.merchatOss.getPrivateImgUrl, {imgUrl: url}).then(ret => {
            if (ret) {
              /**
               * oldImgUrl 代表 没解密之前的图片地址
               * newImgUrl 代表 解密之后的图片地址
               */
              this.$emit("file", {oldImgUrl :url, newImgUrl: ret});
            }
          })
        } else {
          this.$emit("file", url);
        }
      } catch (e) {
        this.$message.warning('页面过期，请重新刷新页面');
        this.getSts();
      }
    },
    async uploadImg(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG && !isPNG) {
        this.$message.error("上传头像图片只能是 JPG 或 PNG 格式!");
        return false;
      }
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
        return false;
      }

      console.log("压缩前文件", file);
      file = await compressImage(file);
      console.log("压缩后文件", file);

      let res = await this.$api.get(this.$url.merchatOss.getSts, {module: this.module })
      if (res) {
        this.oss = new OSS({
          region: process.env.VUE_APP_CURRENTMODE == 'production' ? 'oss-cn-shanghai' : 'oss-cn-beijing',
          accessKeyId: res.accessKeyId,
          accessKeySecret: res.accessKeySecret,
          bucket: res.bucketName,
          stsToken: res.securityToken,
          securityToken: res.securityToken
        })
        this.ossParmar = res;
        this.confirmImg(file);
      }
    },
    async getSts () {
      let res = await this.$api.get(this.$url.merchatOss.getSts, {module: this.module })
      if (res) {
        this.oss = new OSS({
          region: process.env.VUE_APP_CURRENTMODE == 'production' ? 'oss-cn-shanghai' : 'oss-cn-beijing',
          accessKeyId: res.accessKeyId,
          accessKeySecret: res.accessKeySecret,
          bucket: res.bucketName,
          stsToken: res.securityToken,
          securityToken: res.securityToken
        })
        this.ossParmar = res;
      }
    },
    magnifyFileList(url) {
      //放大
      // for(let i in this.srcList){
      //     if(this.myFileList[i] == url){
      //         this.myFileList.splice(i,1);
      //     }
      // }
      // this.myFileList.unshift(url);
    },
    removeFileList(item, index) {
      let imgUrl = JSON.parse(JSON.stringify(this.myFileList));
      this.myFileList = "";
      let obj = {
        imgUrl
      }
      this.$emit("delete", obj);
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/edit.less";
.upload {
  display: flex;
  justify-content: center;
}
/deep/ div .el-upload--picture-card {
  background-color: #fff;
  border-radius: 6px;
  box-sizing: border-box;
  width: 220px;
  height: 140px;
  vertical-align: top;
  
  .icons {
    font-size: 45px;
    color: @blue;
    font-weight: bold;
  }
  img {
    width: 220px;
    height: 140px;
    border-radius: 6px;
    box-sizing: border-box;
  }
}
.el-upload--picture-card {
  display: flex;
  justify-content: center;
  [class^="el-icon-"] {
    line-height: inherit;
  }
}
.flex {
  display: flex;
  flex-direction: row;
}
.delete {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
  &:hover {
    opacity: 1;
    cursor: pointer;
  }
  i {
    text-align: center;
    line-height: 110px;
  }
}
.cardFrontImg /deep/ .el-upload--picture-card {
  background: url("../../../assets/images/new/frontIdCard.png");
  background-size: contain;
  background-repeat: no-repeat;
}
.cardBackImg /deep/ .el-upload--picture-card {
  background: url("../../../assets/images/new/reverseIdCard.png");
  background-size: contain;
  background-repeat: no-repeat;
}
</style>